export default function (gtmId, mode) {
  //if (mode.indexOf("test") === -1) {
    const head = document.getElementsByTagName('head')[0];
    const gtmHead = document.createElement('script');
    gtmHead.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + gtmId + "');";
    head.insertBefore(gtmHead, head.firstChild);
  
    const body = document.getElementsByTagName('body')[0];
    const gtmBody = document.createElement('noscript');
    gtmBody.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + gtmId + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
    body.insertBefore(gtmBody, body.firstChild);
  //}
}